export {};

export const countries = [
    // { code: "ae", country: "United Arab Emirates" },
    { code: "ae", country: "UAE" },
    { code: "sa", country: "Saudi Arabia" },
    { code: "eg", country: "Egypt" },
    { code: "kw", country: "Kuwait" },
    { code: "bh", country: "Bahrain" },
    { code: "qa", country: "Qatar" },
    { code: "om", country: "Oman" },
];

export const clubStatus = [
    { status : "coming_soon", label: "Coming Soon"},
    { status : "request_access", label: "Request Access"},
    { status : "available", label: "Available"},
];

export const currencies = [
    { label : "AED", value: "AED"},
    { label : "KWD", value: "KWD"},
    { label : "SAR", value: "SAR"},
    { label : "OMR", value: "OMR"},
    { label : "BHD", value: "BHD"},
    { label : "QAR", value: "QAR"},
    { label : "USD", value: "USD"},
]
